import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ShieldCheck } from "lucide-react";
import logoImage from "@/assets/ZRSalesCoach.nav.webp";

const navItems = [
  { label: "Home", path: "/" },
  { label: "Over Mij", path: "/over-mij" },
  { label: "Diensten", path: "/diensten" },
  { label: "Blog", path: "/blog" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const isAdminAuthenticated = localStorage.getItem("zr_admin_authenticated") === "true";
    setIsAdmin(isAdminAuthenticated);
  }, [location.pathname]);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-card/80 backdrop-blur-lg border-b border-border">
      <div className="container mx-auto flex items-center justify-between h-16 px-4">
        <Link to="/" className="inline-flex items-center">
          <div className="h-14 w-48 overflow-hidden">
            <img
              src={logoImage}
              width={220}
              height={147}
              alt="SalesCoach Zemar"
              decoding="async"
              fetchPriority="high"
              className="h-full w-full object-contain scale-[1.8] origin-center"
            />
          </div>
        </Link>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm font-medium transition-colors hover:text-accent ${
                location.pathname === item.path ? "text-accent" : "text-muted-foreground"
              }`}
            >
              {item.label}
            </Link>
          ))}
          {isAdmin && (
            <Link
              to="/admin"
              className="flex items-center gap-2 text-sm font-medium text-accent hover:text-accent/80 transition-colors"
            >
              <ShieldCheck size={18} />
              Admin
            </Link>
          )}
          <Link
            to="/contact"
            className="gold-gradient text-accent-foreground px-5 py-2 rounded-md text-sm font-semibold shadow-gold hover:opacity-90 transition-opacity"
          >
            Gratis Intake
          </Link>
        </div>

        {/* Mobile toggle */}
        <button onClick={() => setOpen(!open)} className="md:hidden text-foreground" aria-label="Name">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-card border-b border-border overflow-hidden">
          <div className="flex flex-col gap-2 px-4 py-4">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setOpen(false)}
                className={`text-sm font-medium py-2 transition-colors ${
                  location.pathname === item.path ? "text-accent" : "text-muted-foreground"
                }`}
              >
                {item.label}
              </Link>
            ))}
            {isAdmin && (
              <Link
                to="/admin"
                onClick={() => setOpen(false)}
                className="flex items-center gap-2 text-sm font-medium text-accent py-2"
              >
                <ShieldCheck size={18} />
                Admin
              </Link>
            )}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="gold-gradient text-accent-foreground px-5 py-2.5 rounded-md text-sm font-semibold text-center mt-2"
            >
              Gratis Intake
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
